/**
 * Frontend build-metadata authority.
 *
 * The frontend build SHA / branch / timestamp are injected by
 * ``frontend/scripts/write-build-sha.js`` at build time (``prebuild``).
 * This module is the single place that reads them and publishes them to
 * ``window.__APP_BUILD_SHA__`` / ``window.__APP_BUILD_INFO__`` so any
 * future Cursor task (or a human) can detect source-vs-deployed drift
 * from the browser console without shipping a debug endpoint.
 *
 * See MASTER TRAINING PLAN SETUP / DEPLOYMENT CLOSEOUT (Part 43 —
 * DEPLOYED VERSION AUTHORITY / Part 44 — SOURCE != DEPLOYMENT).
 */
const BUILD_INFO = Object.freeze({
  sha: process.env.REACT_APP_BUILD_SHA || "unknown",
  branch: process.env.REACT_APP_BUILD_BRANCH || "unknown",
  builtAt: process.env.REACT_APP_BUILD_AT || "unknown",
});

if (typeof window !== "undefined") {
  window.__APP_BUILD_SHA__ = BUILD_INFO.sha;
  window.__APP_BUILD_INFO__ = BUILD_INFO;
}

export const getBuildInfo = () => BUILD_INFO;
export const getBuildSha = () => BUILD_INFO.sha;

export default BUILD_INFO;
